export const colors = {
    appPrimary: '#e7440d',
    appBackground: '#d0d0d0',
    black: '#000000',
    green: '#4AC76B',
    white: '#ffffff',
    grey: '#707070',
    lightText: '#afafaf',
    darkGrey: '#676767',
    lightGrey: '#d7d7d7',
    lighterGrey: '#e7e7e7',
    lightestGrey: '#f3f3f3',
    red: '#e7440d',
    lightPink: '#e6b8b8'
} 